import generateUtilityClasses from '@mui/material/generateUtilityClasses';

export const noteClasses = generateUtilityClasses('AFNote', [
  'content',
  'icon',
  'message',
  'variant',
  'action'
]);
